import React from "react";

const StandardBikeWash = () => {
  return (
    <div>
      <div>
        <p className="font-bold">
          This service is only available if premium car wash is booked.
        </p>
        <ul className="list-disc text-black-500 ">
          <li>Pressure Wash only</li>
          <li>Tyre Polish - Paid</li>
          <li>Full Body Shine Coat- Paid</li>
        </ul>
      </div>
    </div>
  );
};

export default StandardBikeWash;
